"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
require("./styles.scss");
const LocationPaymentOptions = ({ title, notes, options, enabledOptions, h2 = false }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const activeOptions = (0, react_1.useMemo)(() => {
        const opts = [];
        for (const key in options) {
            if (enabledOptions.indexOf(key) !== -1) {
                opts.push(t(options[key]));
            }
        }
        return opts;
    }, [options, enabledOptions, t]);
    const heading = (0, react_1.useMemo)(() => {
        const icon = (0, jsx_runtime_1.jsx)("svg", Object.assign({ className: "ontario-icon iconTitleImage", "aria-hidden": "true", focusable: "false", viewBox: "0 0 24 24", preserveAspectRatio: "xMidYMid meet" }, { children: (0, jsx_runtime_1.jsx)("use", { xlinkHref: require("../../assets/ontario-icons-primary.svg").default + "#ontario-icon-credit-card" }) }));
        return h2 ? ((0, jsx_runtime_1.jsxs)("h2", Object.assign({ className: `ontario-h3` }, { children: [icon, title] }))) : ((0, jsx_runtime_1.jsxs)("h3", { children: [icon, title] }));
    }, [title, h2]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "paymentOptions", className: "sidebarSection" }, { children: [title ?
                heading : (""), (0, jsx_runtime_1.jsx)("ul", Object.assign({ className: "paymentOptions" }, { children: activeOptions === null || activeOptions === void 0 ? void 0 : activeOptions.map((option, index) => ((0, jsx_runtime_1.jsx)("li", { children: option }, index))) })), notes === null || notes === void 0 ? void 0 : notes.map((note, index) => ((0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: note }) }, index)))] })));
};
exports.default = LocationPaymentOptions;
